import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SerializedReel } from '../../types';
import { reelMessages, reelVoiceMessages } from './reelMessages';
import { releaseThemeMessages } from '../../themes/releaseThemeMessages';

import { ReelStatusPill } from './ReelStatusPill';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The chips under the player (design c): theme, voice, length and the status pill. */
const ReelMetaChipsComponent: React.FC<{ reel: SerializedReel }> = ({ reel }) => {
  const intl = useIntl();
  const voice = reel.voiceId === null ? reelMessages.noVoiceover : reelVoiceMessages[reel.voiceId].label;

  return (
    <div className={styles.meta}>
      <ReelStatusPill status={reel.status} />
      <span className={styles.mchip}>{intl.formatMessage(releaseThemeMessages[reel.themeId].name)}</span>
      <span className={styles.mchip}>{intl.formatMessage(voice)}</span>
      <span className={styles.mchip}>{intl.formatMessage(reelMessages.seconds, { count: reel.durationSec })}</span>
    </div>
  );
};

export const ReelMetaChips = TypedMemo(ReelMetaChipsComponent);
